import { UIHeading4 } from '@cian/ui-kit/typography';

import { type AnchorHTMLAttributes, type FC } from 'react';

import styles from './Button.css';

type ButtonLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  testId?: string;
};

export const ButtonLink: FC<ButtonLinkProps> = props => {
  const { href, children, testId, onClick } = props;

  return (
    <a className={styles['button']} data-testid={testId} href={href} rel="noreferrer" target="_blank" onClick={onClick}>
      <UIHeading4 color="text-inverted-default" fontWeight="bold">
        {children}
      </UIHeading4>
    </a>
  );
};
